import { tr, uiLocale } from "@/i18n/copy";
import { useUiLanguage } from "@/i18n/useUiLanguage";
import { Star } from "lucide-react";

export function ArtistReviewSummary({ reviews, className = "" }) {
  useUiLanguage();
  const count = Number(reviews?.count || 0);
  return <span className={`inline-flex items-center gap-1 text-xs ${className}`} aria-label={count ? tr("{{rating}} stelle su 5, {{count}} recensioni", {rating: reviews.average, count}) : tr("Nessuna recensione")}>
    <Star className={`h-3.5 w-3.5 ${count ? "fill-amber-400 text-amber-400" : "text-zinc-500"}`} aria-hidden="true" />
    {count ? <><b>{new Intl.NumberFormat(uiLocale(), {minimumFractionDigits:1,maximumFractionDigits:1}).format(Number(reviews.average))}</b><span className="opacity-70">({count})</span></> : <span className="opacity-70">{tr("Nessuna recensione")}</span>}
  </span>;
}

export function ArtistReviewList({ reviews = [] }) {
  useUiLanguage();
  if (!reviews.length) return <p className="text-sm text-muted-foreground">{tr("Ancora nessuna recensione per questo artista.")}</p>;
  return <div className="space-y-2">{reviews.map((review) => <article key={review.id} className="rounded-xl border border-white/10 bg-white/5 p-3">
    <div className="flex items-center gap-2 text-xs"><span className="flex items-center gap-1 text-amber-400"><Star className="h-3.5 w-3.5 fill-current" aria-hidden="true" />{review.rating}/5</span>{review.created_at && <time className="text-muted-foreground" dateTime={review.created_at}>{new Date(review.created_at).toLocaleDateString(uiLocale())}</time>}</div>
    {review.comment && <p className="mt-2 whitespace-pre-wrap break-words text-sm">{review.comment}</p>}
  </article>)}</div>;
}
